import { ChartType } from '../../../core/types/chart-types.js';
import type { HistogramChartConfiguration } from '../../../histogram/types/histogram-props.js';
import { normalizeConfig } from '../../../histogram/utils/histogram-configuration.js';

/**
 * Produces the same Histogram-shaped serialized config payload as the
 * legacy `HistogramChartImperativeHandler.getConfig()`.
 *
 * This is the single source of truth for the export shape consumed by the
 * `HistogramChartConfig` import API and `HistogramChartRef.getConfig()`.
 */
export const serializeHistogramConfig = (
  config: HistogramChartConfiguration,
): string =>
  JSON.stringify({
    type: ChartType.Histogram,
    ...normalizeConfig(config),
  });
